/* NANIMERICA card badges: neighbour rule + click/view tracking.
   Cards: a.nrh-card (snippets/nr-home-card.liquid). Data labels sit in .nrh-card__badges[data-nr-b].
   Neighbour rule: a data label never repeats within the last few cards in reading order
   (columns + 1, so beside, above and diagonal on a 2-column phone grid; at most 4) or the card directly above.
   On a clash the card shows its fallback label (data-nr-fbl) if that doesn't clash too, otherwise no label.
   Sale and low-stock labels are left alone. Re-runs on resize and when new cards appear (filters, load more).
   Tracking: nr_card_click {badge, product, page, position} on every card click (badge 'none' when unlabelled);
   nr_card_views {page, counts:{best:3,none:12,...}} batched, so click rates can be compared per label. */
(function () {
  if (window.__nrCardBadges) return;
  window.__nrCardBadges = true;

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }

  function groupOf(card) {
    var p = card.parentElement;
    for (var i = 0; i < 4 && p; i++) {
      if (p.querySelectorAll('a.nrh-card').length > 1) return p;
      p = p.parentElement;
    }
    return card.parentElement;
  }

  function reset(b) {
    b.hidden = false;
    var s = b.firstElementChild;
    if (s) s.textContent = b.getAttribute('data-nr-bl');
    b.setAttribute('data-nr-cur', b.getAttribute('data-nr-b'));
  }

  function label(card) {
    var b = card.querySelector('.nrh-card__badges[data-nr-b]');
    if (!b || b.hidden) return '';
    return b.getAttribute('data-nr-cur') || '';
  }

  function apply() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('a.nrh-card'));
    var groups = [];
    cards.forEach(function (c) {
      var g = groupOf(c);
      if (groups.indexOf(g) < 0) groups.push(g);
    });
    groups.forEach(function (g) {
      var list = Array.prototype.slice.call(g.querySelectorAll('a.nrh-card')).filter(function (c) { return c.offsetParent !== null; });
      if (!list.length) return;
      list.forEach(function (c) { var b = c.querySelector('.nrh-card__badges[data-nr-b]'); if (b) reset(b); });
      var pos = list.map(function (c) { var r = c.getBoundingClientRect(); return { t: Math.round(r.top + window.scrollY), l: Math.round(r.left + window.scrollX), c: c }; });
      var cols = pos.filter(function (o) { return Math.abs(o.t - pos[0].t) < 6; }).length;
      var k = Math.max(2, Math.min(cols + 1, 4));
      pos.forEach(function (me, i) {
        var b = me.c.querySelector('.nrh-card__badges[data-nr-b]');
        if (!b) return;
        var near = [];
        for (var j = Math.max(0, i - k); j < i; j++) near.push(label(pos[j].c));
        for (var u = i - 1; u >= 0; u--) {
          if (pos[u].t < me.t - 6 && Math.abs(pos[u].l - me.l) < 6) { near.push(label(pos[u].c)); break; }
        }
        var cur = b.getAttribute('data-nr-b');
        if (near.indexOf(cur) < 0) return;
        var fb = b.getAttribute('data-nr-fb');
        if (fb && near.indexOf(fb) < 0) {
          b.firstElementChild.textContent = b.getAttribute('data-nr-fbl');
          b.setAttribute('data-nr-cur', fb);
        } else {
          b.hidden = true;
          b.setAttribute('data-nr-cur', '');
        }
      });
    });
    observeViews();
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(apply, 120); }

  /* Views: each card counted once per page view when half visible. */
  var seen = new WeakSet(), counts = {}, io = null, flushT;
  function flush() {
    if (!Object.keys(counts).length) return;
    track('nr_card_views', { page: location.pathname, counts: counts });
    counts = {};
  }
  function observeViews() {
    if (!('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || seen.has(e.target)) return;
          seen.add(e.target);
          io.unobserve(e.target);
          var key = label(e.target) || 'none';
          counts[key] = (counts[key] || 0) + 1;
          clearTimeout(flushT); flushT = setTimeout(flush, 5000);
        });
      }, { threshold: 0.5 });
    }
    document.querySelectorAll('a.nrh-card').forEach(function (c) { if (!seen.has(c)) io.observe(c); });
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.nrh-card');
    if (!a) return;
    var all = Array.prototype.slice.call(document.querySelectorAll('a.nrh-card'));
    var handle = (a.getAttribute('href') || '').split('/products/')[1] || '';
    flush();
    track('nr_card_click', { badge: label(a) || 'none', product: handle.split('?')[0], page: location.pathname, position: all.indexOf(a) + 1 });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('load', later);
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; later(); } });
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var n = ms[i].addedNodes;
      for (var x = 0; x < n.length; x++) {
        if (n[x].nodeType === 1 && (n[x].matches('a.nrh-card') || n[x].querySelector('a.nrh-card'))) { later(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
